import * as React from 'react';
import Page from '../../components/layout/Page';
import { API_ROUTE, CLIENT_ROUTE, STATEMENT } from './constants';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { IResponse } from '../../types/api';
import { type Statement, StatementStatus } from './types';
import { Box, Button, createStyles, Group, Textarea } from '@mantine/core';
import dayjs from 'dayjs';
import { showMessage } from '../../lib/notification';

interface IDetailRow {
    label: string;
    value: React.ReactNode;
}

const useStyles = createStyles((theme) => {
    return {
        item: {
            display: 'flex',
            width: '100%',
            gap: theme.spacing.md,
            ' > div': {
                flex: 1,
                wordBreak: 'break-word',
                '&:first-of-type': {
                    textAlign: 'right'
                },
                '&:last-of-type': {
                    fontWeight: 500
                }
            }
        },
    }
})

const DetailRow = ({
    value,
    label
}: IDetailRow) => {
    const { classes } = useStyles();
    return (
        <div className={classes.item}>
            <div>{label}</div>
            <div>{value}</div>
        </div>
    )
}

const StatementEdit = () => {

    const { state: id = null } = useLocation();
    const navigate = useNavigate();

    const [ data, setData ] = React.useState<Statement | null>(null);
    const [ description, setDescription ] = React.useState('');

    React.useEffect(() => {
        void fetchData();
    }, []);

    const fetchData = async () => {
        const { data } = await axios.get<IResponse<any>>(`${API_ROUTE}/${id}`);
        setData(data.result);
    };

    const handleSubmit = async () => {
        if (!description) {
            showMessage('Тайлбар оруулна уу')
        } else {
            const params = {
                actionStatus: 'resolved',
                description
            }
            const { data } = await axios.post<IResponse<any>>(`/api/statements/${id}`, params);
            if (data.statusCode === 200) {
                showMessage('Амжилттай', 'green');
                navigate(CLIENT_ROUTE);
            }
        }
    }

    return (
        <Page>
            <Page.Header title={'Гүйлгээ шийдвэрлэх'} backRoute={CLIENT_ROUTE}>

            </Page.Header>
            <Page.Body>
                <Box mt='md'>
                    <DetailRow
                        label={'Төлөв'}
                        value={data?.actionStatus ? STATEMENT?.[data?.actionStatus] : '-'}
                    />
                    <DetailRow label={'Банк'} value={data?.bankType}/>
                    <DetailRow label={'Дансны дугаар'} value={data?.relatedAccount}/>
                    <DetailRow label={'Гүйлгээний утга'} value={data?.transactionInfo}/>
                    <DetailRow label={'Дүн'} value={data?.amount}/>
                    <DetailRow
                        label={'Үүссэн огноо'}
                        value={dayjs(data?.createdAt).format('YYYY-MM-DD HH:mm:ss')}
                    />
                    <DetailRow
                        label={'Засагдсан огноо'}
                        value={dayjs(data?.updatedAt).format('YYYY-MM-DD HH:mm:ss')}
                    />
                    <DetailRow label={'Рекорд дугаар'} value={data?.recordNumber}/>
                    <DetailRow label={'Тайлбар'} value={data?.description}/>
                    <DetailRow label={'Тэмдэглэл'} value={data?.actionNote}/>
                </Box>
                {
                    data?.actionStatus === StatementStatus.FAILED && (
                        <Box sx={{ width: 400 }} mx="auto">
                            <Textarea
                                label='Тайлбар'
                                withAsterisk
                                value={description}
                                onChange={e => setDescription(e.currentTarget.value)}
                            />
                        </Box>
                    )
                }
            </Page.Body>
            <Page.Footer>
                <Group position="right" mt="md">
                    {
                        data?.actionStatus === StatementStatus.FAILED && (
                            <Button
                                onClick={handleSubmit}
                                color='green'
                            >
                                Шийдвэрлэх
                            </Button>
                        )
                    }
                </Group>
            </Page.Footer>
        </Page>
    )
}

export default StatementEdit;